// extracted by mini-css-extract-plugin
module.exports = {"widerPage":"_examples-styles-module--widerPage--1ra46","exampleTitle":"_examples-styles-module--exampleTitle--1Gsbd"};